import { html, LitElement } from 'lit';
import '../../context/step-wizard-context/StepWizardContextProvider';
import './StepWizardProgress';
import styles from './styles';

class StepWizard extends LitElement {
  static styles = styles;

  static properties = {
    activeStep: {
      type: Number,
      reflect: true,
      attribute: 'active-step',
    },
    totalSteps: {
      type: Number,
      reflect: true,
      attribute: 'total-steps',
    },
    showProgressBar: {
      type: Boolean,
    },
    disableProgress: {
      type: Boolean,
      state: true,
    },
    steps: {
      type: Array,
      state: true,
    },
  };

  constructor() {
    super();
    this.activeStep = 0;
    this.totalSteps = 0;
    this.showProgressBar = false;
    this.disableProgress = true;
    this.steps = [];
  }

  getNavStyles = (activeIndex, steps = []) => {
    const stepStyles = [];
    steps.forEach((step, i) => {
      if (i < activeIndex) {
        stepStyles.push('done');
      } else if (i === activeIndex) {
        stepStyles.push('current');
      } else {
        stepStyles.push('incomplete');
      }
    });
    return stepStyles;
  };

  firstUpdated() {
    const slot = this.shadowRoot.querySelector('slot');
    if (slot) {
      const childNodes = slot.assignedElements({ flatten: true });
      this.steps = Array.from(childNodes);
      this.updateSteps(this.steps);
    }
  }

  get slottedChildren() {
    const slot = this.shadowRoot.querySelector('slot');
    return slot ? slot.assignedElements({ flatten: true }) : [];
  }

  handleSlotchange(e) {
    const childNodes = e.target.assignedElements({ flatten: true });
    this.steps = Array.from(childNodes);
    this.updateSteps(this.steps);
  }

  next() {
    this.activeStep += 1;
    this.updateSteps(this.slottedChildren);
  }

  previous() {
    this.activeStep -= 1;
    this.updateSteps(this.slottedChildren);
  }

  setActiveStep(event) {
    this.activeStep = event?.detail?.step ?? this.activeStep;
    this.updateSteps(this.slottedChildren);
  }

  updateSteps(childNodes) {
    this.totalSteps = childNodes?.length ?? 0;

    childNodes.forEach((child, index) => {
      if (index === this.activeStep) {
        child.style.display = 'block';
        child.setAttribute('is-active-step', true);
      } else {
        child.style.display = 'none';
        child.setAttribute('is-active-step', false);
      }

      child.setAttribute('step', index);
      child.setAttribute('active-step', this.activeStep);
      child.setAttribute('total-steps', this.totalSteps);
    });
  }

  render() {
    return html`
      <tenable-step-wizard-provider .value=${{ totalSteps: this.totalSteps, activeStep: this.activeStep }}>
        ${this.showProgressBar ? html`
          <tenable-step-wizard-progress
            .steps=${this.steps}
            .disableProgress=${this.disableProgress}
            .stepStyles=${this.getNavStyles(this.activeStep, this.steps)}
          ></tenable-step-wizard-progress>
        ` : ''}
        <div
          class="step-wizard-steps"
          @next-step=${(e) => this.next(e)}
          @previous-step=${(e) => this.previous(e)}
          @set-active-step=${(e) => this.setActiveStep(e)}
        >
          <slot @slotchange=${this.handleSlotchange}></slot>
        </div>
      </tenable-step-wizard-provider>
    `;
  }
}
customElements.define('tenable-step-wizard', StepWizard);
